export const ArrowDown = ({ width = 16, height = 16, color = "#C53660" }) => (
    <div style={{
        border: "1px solid rgba(197, 54, 96, 0.12)",
        borderRadius: "100px",
        padding: "2px",
        width,
        height,
        background: "rgba(197, 54, 96, 0.12)",
    }}>
        <svg  width={width} height={height}  viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M6 0.75C6.20711 0.75 6.375 0.917893 6.375 1.125V9.96967L8.73483 7.60983C8.88128 7.46339 9.11872 7.46339 9.26517 7.60983C9.41161 7.75628 9.41161 7.99372 9.26517 8.14017L6.26517 11.1402C6.11872 11.2866 5.88128 11.2866 5.73484 11.1402L2.73483 8.14017C2.58839 7.99372 2.58839 7.75628 2.73483 7.60983C2.88128 7.46339 3.11872 7.46339 3.26517 7.60983L5.625 9.96967V1.125C5.625 0.917893 5.79289 0.75 6 0.75Z"
                  fill={color} />
        </svg>
    </div>

);
